export default __webpack_public_path__ + "static/media/top.2d5b7b0a.jpg";